import {LinePlotTemplateSettings} from './workspaceTemplatesQueries';

export const mappedBooleanDisplayValue = (value: boolean) => {
  return value ? 'On' : 'Off';
};

type TemplateSettings = LinePlotTemplateSettings;

type SettingsSection<T extends TemplateSettings> = {
  rows: {field: keyof T; newValue: T[keyof T]}[];
};

/**
 * Extracts non-null values from template settings based on the specified fields.
 * Used to copy template values to workspace settings when applying a template.
 */
export const extractTemplateValues = <T extends TemplateSettings>(
  templateSettings: T | undefined,
  fields: (keyof T)[]
): Partial<T> => {
  if (templateSettings == null) {
    return {};
  }

  const result: Partial<T> = {};
  for (const key of fields) {
    const value = templateSettings[key];
    if (value != null) {
      result[key] = value;
    }
  }
  return result;
};

/**
 * Extracts settings values from template sections.
 * Reduces all rows in all sections to a single settings object using each row's field and newValue.
 */
export const extractSettingsFromSections = <T extends TemplateSettings>(
  sections: SettingsSection<T>[]
): T => {
  return sections.reduce<T>((acc, section) => {
    return section.rows.reduce((acc, row) => {
      acc[row.field] = row.newValue;
      return acc;
    }, acc);
  }, {} as T);
};
